export class RegiaoModel {
    id: number;
    descricao: String;
}


// WEBPACK FOOTER //
// /app/src/app/model/endereco/regiao.model.ts